module.exports = __webpack_public_path__ + "img/shopcart.3f02b594.svg";